import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, } from "@reverb-ui/react";
import React, { useRef } from "react";
export var Popup = function (_a) {
    var title = _a.title, message = _a.message, onClose = _a.onClose, isOpen = _a.isOpen;
    var notificationRef = useRef(null);
    return (React.createElement(AlertDialog, { isOpen: isOpen, onClose: onClose, leastDestructiveRef: notificationRef },
        React.createElement(AlertDialogOverlay, null,
            React.createElement(AlertDialogContent, null,
                React.createElement(AlertDialogHeader, { fontSize: "lg", fontWeight: "bold" }, title),
                React.createElement(AlertDialogBody, null, message),
                React.createElement(AlertDialogFooter, null,
                    React.createElement(Button, { onClick: onClose }, "Close"))))));
};
